<script setup>
import { useDisplay } from 'vuetify'
import RepositoryFactory from '@/repositories/RepositoryFactory'
import { inject, onMounted, onUnmounted, ref, defineProps } from 'vue'
const props = defineProps({
  resource: {
    type: String,
    required: true,
  }
})
const ProfessorRepo = RepositoryFactory.get('Professors')
const professors = ref([])
const storeFourUploadBaseUrl = inject('storeFourBaseUrl')
const onboarding = ref(0) // This value will change when the user clicks next/previous buttons
const width = ref(300)
const { mdAndDown } = useDisplay()
const profSlideGroup = ref(null)

// Set width based on screen size
setTimeout(() => {
  if (mdAndDown.value) {
    width.value = profSlideGroup.value.$el.clientWidth / 1.5
  } else {
    width.value = profSlideGroup.value.$el.clientWidth / 0.5
  }
}, 100)

// Fetch professors' data on component mount
onMounted(async () => {
  try {
    if (props.resource === 'sampad'){
      const { data } = await ProfessorRepo.getSampad()
      professors.value = data
    } else {
      const { data } = await ProfessorRepo.get()
      professors.value = data
    }
  } catch (error) {
    console.error(error)
  }
})
const interval = setInterval(() => {
  onboarding.value+2 <= professors.value.length ? onboarding.value++ : onboarding.value = 0
}, 4000)
onUnmounted(()=>{
  clearInterval(interval)
})
const getImagesSrc = (image) => {
  return `${storeFourUploadBaseUrl}/filepond/profile/${image}`
}
</script>

<template>
  <v-slide-group
    v-model="onboarding"
    center-active
    ref="profSlideGroup"
    mandatory
    mobile-breakpoint="xxl"
    :show-arrows="false"
    mobile
    breakpoint="xl"
  >
    <v-slide-group-item
      v-for="(item, index) in professors"
      :key="index"
      v-slot="{ isSelected, select }"
    >
      <div
        class="new-home prof-details m-2"
        :class="{ not__selected: !isSelected && $vuetify.display.mdAndUp }"
      >
        <div class="card-v3" @click="select">
          <figure>
            <img
              :src="getImagesSrc(item.profile.user_img_files.img_1)"
              :class="[$vuetify.display.mdAndDown ? 'mobile-image' : '']"
              :alt="item.name"
            />
            <figcaption class="card__caption card__caption__home">
              <p class="card__title">{{ item.name }}</p>
              <p class="animated-text" v-html="item.bio"></p>
              <v-btn
                style="letter-spacing: 0"
                class="text-decoration-none align-self-center"
                width="40%"
                :to="{ name: 'professor', params: { userId: item.id } }"
                variant="text"
                color="#004EEB"
              >
                مشاهده بیشتر
              </v-btn>
            </figcaption>
          </figure>
        </div>
      </div>
    </v-slide-group-item>
  </v-slide-group>

</template>

<style scoped lang="scss">
.not__selected {
  opacity: 0.3;
  cursor: pointer;
  transition: box-shadow 0.3s ease, opacity 0.3s ease; // Smooth transition for the border effect

}

.prof-details.new-home {
  @include media-breakpoint-up(md){
    min-width:380px;
  }
  img{
    @include media-breakpoint-up(md){
      max-width: 380px;
      max-height: 380px;
    }
  }
  .mobile-image {
    max-width: 270px;
  }

  p {
    &:nth-child(2) {
      font-size: 12px;
      margin-bottom: 25px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3; /* Number of lines displayed before it truncate */
      overflow: hidden;
    }
  }

  a {
    letter-spacing: 0;
    position: absolute;
    bottom: 15px;
  }
}

.card__caption__home {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border: 1px #eaecf0 solid;
  border-radius: 0 0 26px 26px;
  @include media-breakpoint-up(md){
    min-height: 120px;
  }
}
.animated-text {
  max-height: 100px; /* Initial truncated height */
  overflow: hidden;
  position: relative;
  transition: max-height 0.5s ease-out; /* Smooth transition for height */
}

.animated-text::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height:65px; /* Adjust the height of the fading effect */
  background: linear-gradient(transparent, white); /* Fade effect */
  pointer-events: none; /* Make sure this doesn't block clicks */
}
</style>